export enum LoadingStages {
  PROFILE = "@ENUMS.LOADING_STAGES.PROFILE|Preparing personal profile",
  METADATA = "@ENUMS.LOADING_STAGES.METADATA|Resolving metadata",
  DATA = "@ENUMS.LOADING_STAGES.DATA|Loading data",
  NONE = "@COMMON.WAIT|Wait Please"
}
